import React from 'react';
import { QueryVal } from 'Helpers/Query';
import closeModal from 'Helpers/ModalHelper';
import Drawer from 'Components/Ant/Drawer';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import LoadingRipple from 'Components/UI/LoadingRipple';
import Member from 'Components/Flyouts/HouseholdInfo/Sections/Member/Member';
import EmailPicker from 'Components/Flyouts/HouseholdInfo/Sections/Email/EmailPicker';
import BillingPicker from 'Components/Flyouts/HouseholdInfo/Sections/BillingPicker/BillingPicker';
import SecuritySection from 'Components/Flyouts/HouseholdInfo/Sections/Security/Section';
import { dataAttrs } from 'Helpers/Testing';
import Service from './Sections/Service/Service';
import Escalated from './Sections/Escalated';

function HouseholdInfoFlyout() {
  const handleClose = () => {
    closeModal();
  };

  const {
    householdResource,
    household,
  } = useSimpleHousehold();

  return (
    <Drawer visible width={500} onClose={handleClose} zIndex={1201}>
      <div className="household-info-flyout" {...dataAttrs('household-info-flyout')}>
        {householdResource && household && household.id > 0 ? (
          <>
            <Member householdResource={householdResource} />
            <EmailPicker resource={householdResource} />
            <BillingPicker resource={householdResource} />
            <Service householdResource={householdResource} />
            <SecuritySection householdResource={householdResource} />
            <Escalated
              household={household}
              householdResource={householdResource}
            />
          </>
        ) : (
          <div>
            {`Loading household [${QueryVal('householdId')}]`} <LoadingRipple />
          </div>
        )}
      </div>
    </Drawer>
  );
}

export default HouseholdInfoFlyout;
